import { FCX, usePlatformContext } from "@datassential/platform-ui-lib";
import useFoodProfileRefresh from "@pages/Food/hooks/useFoodProfileRefresh";
import FoodLegacy from "@pages/Food/legacy/FoodLegacy";
import FoodRefresh from "@pages/Food/refresh/FoodRefresh";

/**
 * Food Profile route entry: the ONLY place the `Food Profile Refresh` flag is read.
 *
 *   legacy/   page as it is with the flag off (frozen)
 *   refresh/  page with the flag on (all refresh work goes here)
 *   components/, hooks/, Food.*.scss   shared by both versions
 *
 * Removing the flag:
 *   1. delete `legacy/`, `hooks/useFoodProfileRefresh*` and `Food.test.tsx`
 *   2. drop FOOD_PROFILE_REFRESH_FLAG from `Food.constants.ts`
 *   3. make this file `export { default } from "@pages/Food/refresh/FoodRefresh";`
 * Nothing in `refresh/` or the shared folders needs to change.
 */
const Food: FCX = () => {
    const { isUserInfoLoaded } = usePlatformContext();
    const isRefreshEnabled = useFoodProfileRefresh();

    // Feature flags arrive with the user info, a render after the app mounts. Picking a version
    // before then would mount the legacy page, fire its requests, then swap to the refresh page.
    if (!isUserInfoLoaded) return null;

    return isRefreshEnabled ? <FoodRefresh/> : <FoodLegacy/>;
};

export default Food;
